import { twMerge } from "tailwind-merge";

export const SpotlightSharedCardImageContainer = ({
  className,
  children,
}: {
  className?: string;
  children: React.ReactNode;
}) => {
  return (
    <div
      className={twMerge(
        "relative h-40 min-w-[200px] cursor-pointer overflow-clip bg-white",
        className,
      )}
    >
      {children}
    </div>
  );
};
